var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actions as connectionsActions } from "../../Connections";
import { openPanel } from "../actions/uiActions";
import ShowIf from "../../App/ShowIf";
import { Icon } from "../../UI";
import { Translate } from "../../I18N";

import { addToToc } from "../actions/documentActions";

export class ViewerTextSelectedMenu extends Component {
  showPanel(type) {
    this.props.openPanel('viewMetadataPanel');
    this.props.startNewConnection(type, this.props.doc.get('sharedId'));
  }

  render() {
    return /*#__PURE__*/(
      _jsx("div", { className: this.props.active ? 'active' : '' }, void 0, /*#__PURE__*/
      _jsx(ShowIf, { if: this.props.hasRelationTypes }, void 0, /*#__PURE__*/
      _jsx("div", {
        className: "btn btn-primary connect-to-p",
        onClick: this.showPanel.bind(this, 'targetRanged') }, void 0, /*#__PURE__*/

      _jsx("span", { className: "ContextMenu-tooltip" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Connect to a paragraph")
      ), /*#__PURE__*/
      _jsx(Icon, { icon: "paragraph" })
      )
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: this.props.hasRelationTypes }, void 0, /*#__PURE__*/
      _jsx("div", {
        className: "btn btn-primary connect-to-d",
        onClick: this.showPanel.bind(this, 'ranged') }, void 0, /*#__PURE__*/

      _jsx("span", { className: "ContextMenu-tooltip" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Connect to a document")
      ), /*#__PURE__*/
      _jsx(Icon, { icon: "file" })
      )
      ), /*#__PURE__*/
      _jsx("div", {
        className: "btn btn-primary add-toc",
        onClick: this.props.addToToc.bind(null, this.props.reference.toJS(), this.props.file.toc) }, void 0, /*#__PURE__*/

      _jsx("span", { className: "ContextMenu-tooltip" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Add to table of contents")
      ), /*#__PURE__*/
      _jsx(Icon, { icon: "font" })
      )
      ));

  }
}












function mapStateToProps({ documentViewer, relationTypes }) {
  return {
    doc: documentViewer.doc,
    reference: documentViewer.uiState.get('reference'),
    hasRelationTypes: !!relationTypes.size
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      startNewConnection: connectionsActions.startNewConnection,
      openPanel,
      addToToc
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewerTextSelectedMenu);